import React from 'react'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Paper from '@material-ui/core/Paper'
import { SvgIcon } from '@material-ui/core'
import VideoContent from '../VideoContent'
import useStyles from './styled'

function VdoIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        d="M2.8125 7.03125H17.8125C18.8071 7.03125 19.7609 7.42634 20.4641 8.1296C21.1674 8.83286 21.5625 9.78669 21.5625 10.7812V22.0312C21.5625 22.2799 21.4637 22.5183 21.2879 22.6942C21.1121 22.87 20.8736 22.9688 20.625 22.9688H5.625C4.63044 22.9688 3.67661 22.5737 2.97335 21.8704C2.27009 21.1671 1.875 20.2133 1.875 19.2188V7.96875C1.875 7.72011 1.97377 7.48165 2.14959 7.30584C2.3254 7.13002 2.56386 7.03125 2.8125 7.03125V7.03125Z"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.5625 13.125L28.125 9.375V20.625L21.5625 16.875"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SvgIcon>
  )
}

const VideoPlayback = (props) => {
  const { eventStyles, streamData, onClick } = props
  const classes = useStyles({ eventStyles })
  const videoList = streamData.data_live.video_list || []
  return (
    <Paper className={classes.paper}>
      <div className={classes.title}>
        <VdoIcon className={classes.icon} viewBox="0 0 30 30" htmlColor={'transparent'} />
        Video Playback
      </div>
      <div>
        <List component="nav" aria-label="vdoPlayer">
          {videoList.map((row) => {
            return (
              <ListItem
                onClick={() => {
                  onClick(row.video_id)
                }}
                button
                key={row.video_id}
              >
                <ListItemText disableTypography classes={{ root: classes.rootListItemText }}>
                  <div className={classes.vdoSection}>
                    <div className={classes.vdoPlayer}>
                      <VideoContent
                        liveId={row.video_id}
                        height={'76px'}
                        width={'124px'}
                        controls={false}
                      />
                    </div>
                    <div className={classes.vdoDetails}>{row.name}</div>
                  </div>
                </ListItemText>
              </ListItem>
            )
          })}
        </List>
      </div>
    </Paper>
  )
}

export default VideoPlayback
